import React from 'react';
import { Col, CountrySelect, Form, Paper, Radio, Row, TextField } from '@ui';
import { CreateWorkspaceForm } from '../../CreateWorkspace.schema';
import { useIntl } from 'react-intl';
import { useTheme } from 'styled-components';
import InstitutionsSelect from '@components/common/institutions-select';

const gte = (e: any) => e;

const InstitutionForm: React.FunctionComponent = () => {
  const form = Form.useFormContext<CreateWorkspaceForm>();
  const theme = useTheme();
  const { formatMessage } = useIntl();

  return (
    <Form.Section label="Adresa">
      <Paper
        style={{
          padding: '12px 12px',
          paddingTop: 0,
          borderRadius: theme.radius.small,
          marginBottom: theme.spacings.component.XS,
          border: `2px solid ${theme.color.border.emphasis}`,
        }}
      >
        <Form.Field name="institutionVariant">
          <Radio.Group layout="horizontal">
            <Radio value={'search'}>Vyhľadať</Radio>
            <Radio value={'custom'}>Zadať adresu</Radio>
          </Radio.Group>
        </Form.Field>
        {form.values.institutionVariant === 'search' ? (
          <>
            <Form.Field name="institution" getValueFromEvent={gte} label="Inštitúcia" required>
              <InstitutionsSelect />
            </Form.Field>
          </>
        ) : (
          <>
            <Form.Field name="address" label="Ulica a číslo" required>
              <TextField />
            </Form.Field>
            <Row gutter={[24, 0]}>
              <Col xs={12} md={6}>
                <Form.Field name="postCode" label="PSČ" required>
                  <TextField />
                </Form.Field>
              </Col>
              <Col xs={12} md={6}>
                <Form.Field name="city" label="Mesto" required>
                  <TextField />
                </Form.Field>
              </Col>
            </Row>
            <Form.Field name="country" label="Krajina" required getValueFromEvent={gte}>
              <CountrySelect useAuthCountries />
            </Form.Field>
          </>
        )}
      </Paper>
      <Form.Field
        name="addressInfo"
        label={formatMessage({ id: 'departments_modal_moreInformation' })}
      >
        <TextField.TextArea autoSize={{ maxRows: 10, minRows: 2 }} />
      </Form.Field>
    </Form.Section>
  );
};

export default React.memo(InstitutionForm);
